import { Row } from 'components/SectionedTable';

export const CONSIDERATION_ROWS: Array<Row> = [
  {
    key: 'unitsRealised',
    label: 'Units realised',
    group: '1',
  },
  {
    key: 'receivedConsiderationTotal',
    label: 'Received consideration',
    group: '1',
  },
  {
    key: 'receivedConsiderationPerUnit',
    label: 'Received consideration per unit',
    group: '1',
  },
  {
    key: 'escrowConsiderationTotal',
    label: 'Escrow consideration',
    group: '1',
  },
  {
    key: 'escrowConsiderationPerUnit',
    label: 'Escrow consideration per unit',
    group: '1',
  },
  {
    key: 'earnoutConsiderationTotal',
    label: 'Earnout consideration',
    group: '1',
  },
  {
    key: 'earnoutConsiderationPerUnit',
    label: 'Earnout consideration per unit',
    group: '1',
  },
  {
    key: 'withholdingTaxPayable',
    label: 'Withholding tax payable',
    group: '1',
  },
];
